import React from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowRight, Building2 } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { PageHero, Reveal, SectionTag } from "../components/shared";
import { OFFICE_IMAGES, IMAGES } from "../constants/images";
import { COMPANY } from "../i18n/translations";

export default function GlobalPresence() {
  const { t } = useLang();

  return (
    <div data-testid="global-page">
      <PageHero tag={t.homeGlobal.tag} title={t.global.heroTitle} subtitle={t.global.heroSubtitle} image={IMAGES.dubai} />

      <section className="relative py-16">
        <div className="max-w-7xl mx-auto px-6 md:px-12 space-y-8">
          {t.global.offices.map((o, i) => {
            const reverse = i % 2 === 1;
            return (
              <Reveal key={i} delay={0.04}>
                <div
                  data-testid={`office-card-${i}`}
                  className="grid lg:grid-cols-2 gap-0 items-stretch rounded-[2rem] border border-white/10 bg-[#0F0F12] overflow-hidden"
                >
                  <div className={`relative h-72 lg:h-auto min-h-[300px] ${reverse ? "lg:order-2" : ""}`}>
                    <img src={OFFICE_IMAGES[i]} alt={o.city} className="w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0F0F12]/60 to-transparent" />
                    {i === 0 && (
                      <span className="absolute top-5 left-5 px-3 py-1.5 rounded-full glass font-mono text-[11px] uppercase tracking-wider text-[#00E5FF]">
                        HQ
                      </span>
                    )}
                  </div>
                  <div className={`p-8 lg:p-14 flex flex-col justify-center ${reverse ? "lg:order-1" : ""}`}>
                    <div className="font-mono text-xs uppercase tracking-[0.2em] text-[#00E5FF] flex items-center gap-2">
                      <Building2 className="h-4 w-4" />
                      {o.type}
                    </div>
                    <h2 className="mt-4 text-3xl md:text-4xl font-bold text-white">{o.city}</h2>
                    <div className="mt-2 flex items-center gap-2 text-zinc-400">
                      <MapPin className="h-4 w-4 text-[#1E90FF]" />
                      {o.country}
                    </div>
                    <p className="mt-5 text-zinc-400 text-lg leading-relaxed">{o.desc}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      <section className="relative py-20">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Reveal>
            <div className="rounded-[2rem] border border-white/10 bg-gradient-to-br from-[#0d1b2e] to-[#0F0F12] p-12 text-center relative overflow-hidden">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[400px] h-[260px] bg-[#1E90FF]/20 blur-[100px] rounded-full" />
              <SectionTag>{t.contact.emailLabel}</SectionTag>
              <h2 className="relative mt-4 text-2xl md:text-3xl font-bold text-white">{COMPANY.email}</h2>
              <Link to="/contact" data-testid="global-cta-contact" className="relative mt-7 inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#1E90FF] hover:bg-[#3B82F6] text-white font-semibold transition-all hover:-translate-y-0.5">
                {t.common.getInTouch} <ArrowRight className="h-5 w-5" />
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
